export default {
    name: 'GtmTracker',
    props: {
        trackData: {
            type: String,
            required: true
        }
    },
    setup(props) {
        if (!props.trackData || !window.dataLayer) return

        window.dataLayer.push({ ecommerce: null }) // Clear the previous ecommerce object.
        window.dataLayer.push(props.trackData)
    }
}
